import { useEffect, useState } from "react";

const LoadingMessage = () => {
    const messages = [
        "Preparing your designs...",
        "Loading thumbnails...",
        "Almost ready...",
    ];

    const [index, setIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((i) => (i + 1) % messages.length);
        }, 3000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div
            style={{
                textAlign: "center",
                padding: "60px 20px",
                fontSize: "24px",
                color: "#666",
                width: "100%",
                height: "100%",
                paddingTop: "100px",
            }}
        >
            <div style={{ fontSize: "48px", marginBottom: "20px" }}>⚡</div>
            <p>{messages[index]}</p>
        </div>
    );
};
export default LoadingMessage;
